import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { RuleGroup } from './../rule-group.model';
import { RuleManagementService } from 'app/admin/rules/rule-management.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { MessageService } from 'app/services/messages.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

@Component({
    selector: 'add-rulegroup',
    templateUrl: './add-rulegroup.component.html',
    styleUrls: ['./add-rulegroup.component.css']
})
/**
 * Component to add a new rule group.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class AddRuleGroupComponent implements OnInit {

    selectedRuleGroup: RuleGroup;
    action: string;
    ruleGroupForm: FormGroup;
    groupId: number;
    groupName: string;
    savingRuleGroup = false;

    formErrors = {
        'groupName': '',
    };

    validationMessages = {
        'groupName': {
            'required': 'Required field value.',
        },

    };

    constructor(
        public dialogRef: MdDialogRef<any>,
        private fb: FormBuilder,
        private ruleManagementService: RuleManagementService,
        private snackBarService: SnackBarService,
        private trackingService: TrackingService
    ) { }

    ngOnInit() {
        this.createForm();
        this.updateRuleGroupForm();
    }

    createForm() {
        this.ruleGroupForm = this.fb.group({
            groupName: ['', Validators.required],
        });
        this.ruleGroupForm.valueChanges.subscribe(data => this.onValueChanged(data));
        this.onValueChanged();
    }

    onValueChanged(data?: any) {
        if (!this.ruleGroupForm) {
            return;
        }
        const form = this.ruleGroupForm;
        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control && control.touched && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    this.formErrors[field] += messages[key] + ' ';
                }
            }
        }
    }

    onSubmit({ value, valid }): void {
        const rulegroup = new RuleGroup();
        rulegroup.groupId = this.groupId;
        rulegroup.groupName = value.groupName.trim();
        this.ruleManagementService.addRuleGroup(rulegroup)
            .subscribe(
            success => {
                this.savingRuleGroup = false;
                if (success.flagResult) {
                    this.dialogRef.close(success.arrResult);
                }
                this.trackingService
                    .emitEvent(
                    TrackingConstants.RULE_MANAGEMENT,
                    TrackingConstants.SAVE_RULE_GROUP,
                    TrackingConstants.SUCCESS, 1);
                this.callSnackBarService(success, this.action);
            },
            err => {
                this.savingRuleGroup = false;
                this.trackingService
                    .emitEvent(
                    TrackingConstants.RULE_MANAGEMENT,
                    TrackingConstants.SAVE_RULE_GROUP,
                    TrackingConstants.FAILURE, 0);
                this.callSnackBarService(err, this.action);
            }
            );
    }
    callSnackBarService(response: any, operation: string) {
        this.snackBarService
            .showStatus(response,
            operation === 'Add'
            && MessageService.ADD_RULE_GROUP_SUCCESS || MessageService.UPDATE_RULE_GROUP_SUCCESS,
            MessageService.ADD_RULE_GROUP_FAILURE);
    }
    closeDialog(formResponse: Object): void {
        this.ruleGroupForm.reset();
        this.dialogRef.close(formResponse);
    }
    updateRuleGroupForm(): void {
        if (this.selectedRuleGroup) {
            this.groupId = this.selectedRuleGroup.groupId;
            this.groupName = this.selectedRuleGroup.groupName;
            this.ruleGroupForm.patchValue({
                groupName: this.selectedRuleGroup.groupName,
            });
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/admin/rules/addrulegroup/add-rulegroup.component.ts